import { FC, FormEvent, useEffect, useState } from "react";

export class StaticInfoProps {
  title: string = '';
  value: string = '';
}

export const StaticInfo: FC<StaticInfoProps> = ({title, value}) => {
  return <>
    <div className="py-6 px-2 flex justify-start border-b border-gray-200">
      <h2 className="mr-4 min-w-[170px] font-bold">{title}</h2>
      <div className="">{value}</div>
    </div>
  </>;
}